import request from "../utils/request";

export const getDocumentsClassifications = '/documents/classification';

export function getAllDocumentsClassifications() {
    return request.request({
        method: 'get',
        url: '/documents/classification/dict',
    })
}

export function modifyDocumentsClassifications(data: any) {
    return request.request({
        url: '/documents/classification',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteDocumentsClassifications(id: number) {
    return request.request({
        url: '/documents/classification',
        method: 'delete',
        params: {classificationId: id}
    })
}


export const getDocuments = '/documents/'

export function addDocument(data: any) {
    return request.request({
        url: '/documents/',
        method: 'post',
        data: data
    })
}


export function deleteDocument(id: number) {
    return request.request({
        url: '/documents/',
        method: 'delete',
        params: {documentId: id}
    })
}
